import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ProgressBar } from '@shopify/polaris';

const propTypes = {
  total: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired,
  textStyle: PropTypes.object,
  containerClass: PropTypes.string,
};

const defaultProps = {
  containerClass: "",
  textStyle: {
    textAlign: "right"
  },
  quantityReturned: 0,
}

const QuantityProgress = (props) => {
  const anyQuantityReturned = props.quantityReturned > 0;
  return (
    <div className={ props.containerClass}
       style={ anyQuantityReturned ? {position: "relative"} : {position: "inherit"}} >
      <ProgressBar progress={ calculateProgress(props.quantity, props.total) }/>
      {  anyQuantityReturned &&

        <div className= {`Progress-Returned ${findClassRadius(props.quantity, props.quantityReturned, props.total)}`}
         style={
          {width: `${calculateProgress(props.quantityReturned, props.total)}%`,
          left: `${calculateProgress(props.quantity, props.total)}%` }
         }></div>
      }
      <p className="mt5" style={ props.textStyle }>
        { props.quantity } de { props.total } { anyQuantityReturned && `(${props.quantityReturned} ${props.quantityReturned > 1 ? 'devueltos' : 'devuelto'})` }
      </p>
      
    </div>
  )
};

const calculateProgress = (quantity, total) => {
  if(total >= 1){
    const progress = (quantity * 100.0)/total;
    return progress <= 100 ? progress : 100; // Progress shouldn't be higher than 100
  }
  else{
    return 0; // DO NOT display progress if 0/0
  }
}

const findClassRadius = (quantity, quantityReturned, total) => {
  if( quantity > 0 ){
    if( (quantity + quantityReturned) === total ){
      return 'right-radius'
    }
  }else {
    if(quantity == 0 && quantityReturned == total){
      return 'full-radius'
    }else{
      return 'left-radius'
    }
  }
}

QuantityProgress.propTypes = propTypes;
QuantityProgress.defaultProps = defaultProps;


export default QuantityProgress;